export function createXLSheetdata(ticketList) {
    ticketList.find((ticketDetails, index) => {
                
               
                ticketList[index].Ticket_Id=ticketList[index].id
                delete ticketList[index]['id']

                ticketList[index].Created=ticketList[index].created
                delete ticketList[index]['created']

                ticketList[index].City=ticketList[index].city_name
                delete ticketList[index]['city_name']

                ticketList[index].Kitchen_Name=ticketList[index].kitchen_name
                delete ticketList[index]['kitchen_name']

                ticketList[index].Store_Name=ticketList[index].store_name
                delete ticketList[index]['store_name']

                ticketList[index].Menu_Name=ticketList[index].menu_name
                delete ticketList[index]['menu_name']

                ticketList[index].Platform=ticketList[index].platform
                delete ticketList[index]['platform']

                ticketList[index].Type=ticketList[index].type
                delete ticketList[index]['type']

                ticketList[index].Reason=ticketList[index].reason_name
                delete ticketList[index]['reason_name']

                ticketList[index].Remarks=ticketList[index].remarks
                delete ticketList[index]['remarks']

                ticketList[index].ResolvedBy=ticketList[index].resolver_name
                delete ticketList[index]['resolver_name']

                ticketList[index].Status=ticketList[index].status
                delete ticketList[index]['status']


                ticketList[index].ModifiedOn=ticketList[index].modified
                delete ticketList[index]['modified']


                ticketList[index].Product_SKU=ticketList[index].product_sku
                delete ticketList[index]['product_sku']

                ticketList[index].Product_Name=ticketList[index].product_name
                delete ticketList[index]['product_name']

                ticketList[index].Product_Reason=ticketList[index].product_reason
                delete ticketList[index]['product_reason']

                ticketList[index].Product_Remarks=ticketList[index].product_remarks
                delete ticketList[index]['product_remarks']

                delete ticketList[index]['menu_ticket_details']

                return false
            })   
            return ticketList
}




// WEBPACK FOOTER //
// ./src/modules/Order Verification/services/helpers.js